// export const EMAILJS_SERVICE_ID ="service_b9cmq4d"
export const EMAILJS_SERVICE_ID ="service_3fx1jfp"
export const EMAILJS_Template_ID="template_4rhyljd"
export const EMAILJS_USERID = "uTRmFGAAzLi5ph1V6"
// export const Amount = "60000"